import React, { Component } from "react";
import { Modal, Card } from "react-bootstrap";
import "../styling/Styles.css";
import {  FormGroup, Col, Row } from "reactstrap";
import Button from "@material-ui/core/Button";
import { connect } from "react-redux";
import { SelectArticle } from "../../redux/actions/GetArticles";
import { TextField, Fab, IconButton } from "@material-ui/core";
import "./ss.scss";
import Center from "react-center";
import Snackbar from "@material-ui/core/Snackbar";
import Alert from "@material-ui/lab/Alert";
import DeleteIcon from "@material-ui/icons/Delete";
import Tooltip from "@material-ui/core/Tooltip";
import EditIcon from "@material-ui/icons/Edit";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Switch from "@material-ui/core/Switch";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import { SelectBCFrs } from "../../redux/actions/GetBCFrs";
import { SelectFournisseur } from "../../redux/actions/GetFournisseur";

class ModifierBCFrsModal extends Component {
  constructor(props) {
    super(props);
    const username = localStorage.getItem("username");

    this.state = {
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: "",
      remisea: 0,
      tva: 0,
      puttcnet: 0,
      faudec: "N",
      tab: [],
      totalqte: 0,
      sumremisearticle: 0,
      totalhtbrut: 0,
      totaltva: 0,
      totalhtnet: 0,
      remiseglobal: 0,
      netapayer: 0,
      snackbaropen: false,
      snackbarfail: false,
      editModalShow: false,
      qtte: 0,
      btnEnabled: false,
      gilad: true,
      giladd: true,
      pmps: "",
      rechs: [],
      rechsc: [],
      codtvaa: 0,
      ttclig: "",

      changeButton: false,

      remiseg: 0,
      raisonsocial: "",
      codeclient: "",
      categoriefiscale: "",

      datebcc: "",
      regimecli: "",
      username: username,
      clicked: false,
      clickeda: false,
    };
  }

  componentDidMount() {
    this.props.SelectArticle(
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );
    this.sameTable();
    this.props.SelectFournisseur(
      this.props.ConfigDossier.coddos,
      this.props.ConfigDossier.serveur,
      this.props.ConfigDossier.utilisateur,
      this.props.ConfigDossier.pwd_serveur,
      this.props.ConfigDossier.database
    );

    this.setState({
      remiseg: this.props.taurem,
      raisonsocial: this.props.raisonsociale,
      codeclient: this.props.client,
      categoriefiscale: this.props.catfisc,
      regimecli: this.props.regimecli,
      datebcc: new Date().toISOString().substr(0, 10),
    });
  }

  datHandler = (event) => {
    this.setState({ datebcc: event.target.value });
  };

  raisocHandler = (event) => {
    this.setState({ raisonsocial: event.target.value });
  };

  remiseglobalChange = (event) => {
    this.setState({ remiseg: event.target.value });
  };

  articleHandlerChange = (event) => {
    fetch(
      `https://www.24-crm.tn/webservice/api/ARTICLEs?codartt=${event.target.value}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ rechs: data, clickeda: true }));
  };

  clientHandlerChange = (event) => {
    fetch(
      `https://www.24-crm.tn/webservice/api/FOURNISSEURs?codfrss=${event.target.value}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => this.setState({ rechsc: data, clicked: true }));
  };

  puhtHandler = (event) => {
    this.setState({
      puht: event.target.value,
      totalht: Number(
        this.state.qte * event.target.value * ((100 - this.state.remisea) / 100)
      ).toFixed(3),
      puttcnet: Number(
        event.target.value *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
      ttclig: Number(
        event.target.value *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100) *
          this.state.qte
      ).toFixed(3),
    });
  };

  remiseHandler = (event) => {
    this.setState({
      remisea: event.target.value,
      totalht: Number(
        this.state.qte * this.state.puht * ((100 - event.target.value) / 100)
      ).toFixed(3),
      puttcnet: Number(
        this.state.puht *
          (1 + this.state.tva / 100) *
          ((100 - event.target.value) / 100)
      ).toFixed(3),
      ttclig: Number(
        this.state.puht *
          (1 + this.state.tva / 100) *
          ((100 - event.target.value) / 100) *
          this.state.qte
      ).toFixed(3),
    });
  };

  modifiermodification = (event) => {
    // event.preventDefault();

    const newtab = this.state.tab.concat({
      codart: this.state.codearticle,
      desart: this.state.des,
      quantite: this.state.qte,
      unite: this.state.unite,
      priuni: this.state.puht,
      remise: this.state.remisea,
      tautva: this.state.tva,
      montht: this.state.totalht,
      PUTTCNET: this.state.puttcnet,
      codtva: this.state.codtvaa,
      pmp: this.state.pmps,
      ttclig: this.state.ttclig,
    });

    const SumQte =
      newtab && newtab.reduce((a, v) => a + parseInt(v.quantite), 0);
    const SumRemiseArticle =
      newtab &&
      newtab.reduce(
        (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
        0
      );
    const SumHtBrut =
      newtab && newtab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
    const SumTva =
      newtab &&
      newtab.reduce(
        (a, v) =>
          a +
          parseInt(v.quantite) *
            v.priuni *
            ((100 - v.remise) / 100) *
            (v.tautva / 100),
        0
      );
    const SumHtNet =
      newtab &&
      newtab.reduce((a, v) => a + v.montht * ((100 - this.props.rem) / 100), 0);
    const SumRemiseGlobale =
      newtab &&
      newtab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
    const SumNetAPayer =
      newtab &&
      newtab.reduce(
        (a, v) =>
          a +
          (v.montht * ((100 - this.props.rem) / 100) +
            v.quantite *
              v.priuni *
              ((100 - v.remise) / 100) *
              (v.tautva / 100)),
        0
      );

    this.setState({
      tab: newtab,

      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,

      totaltva: SumTva,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      snackbaropen: true,
      btnEnabled: true,
      changeButton: false,
    });

    this.setState({
      codearticle: "",
      qte: "",
      totalht: 0,
      des: "",
      unite: "",
      puht: "",
      remisea: 0,
      tva: 0,
      puttcnet: 0,
      faudec: "N",
      pmps: "",
      stkfin: 0,
      codtvaa: 0,
      ttclig: "",
    });
  };
  submitHandler = (event) => {
    event.preventDefault();
    if (
      this.state.tab.filter((el) => el.codart === this.state.codearticle)
        .length > 0
    ) {
      alert("article existant, veuillez modifier la quantité ");
    } else {
      const newtab = this.state.tab.concat({
        codart: this.state.codearticle,
        desart: this.state.des,
        quantite: this.state.qte,
        unite: this.state.unite,
        priuni: this.state.puht,
        remise: this.state.remisea,
        tautva: this.state.tva,
        montht: this.state.totalht,
        PUTTCNET: this.state.puttcnet,
        pmp: this.state.pmps,
        codtva: this.state.codtvaa,
        ttclig: this.state.ttclig,
      });
      const SumQte =
        newtab && newtab.reduce((a, v) => a + parseInt(v.quantite), 0);
      const SumRemiseArticle =
        newtab &&
        newtab.reduce(
          (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
          0
        );
      const SumHtBrut =
        newtab &&
        newtab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
      const SumTva =
        newtab &&
        newtab.reduce(
          (a, v) =>
            a +
            parseInt(v.quantite) *
              v.priuni *
              ((100 - v.remise) / 100) *
              (v.tautva / 100),
          0
        );
      const SumHtNet =
        newtab &&
        newtab.reduce(
          (a, v) => a + v.montht * ((100 - this.props.rem) / 100),
          0
        );
      const SumRemiseGlobale =
        newtab &&
        newtab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
      const SumNetAPayer =
        newtab &&
        newtab.reduce(
          (a, v) =>
            a +
            (v.montht * ((100 - this.props.rem) / 100) +
              v.quantite *
                v.priuni *
                ((100 - v.remise) / 100) *
                (v.tautva / 100)),
          0
        );

      this.setState({
        tab: newtab,
        totalht: SumHtNet,

        totalqte: SumQte,
        sumremisearticle: SumRemiseArticle,
        totalhtbrut: SumHtBrut,
        totaltva: SumTva,
        totalhtnet: SumHtNet,
        remiseglobal: SumRemiseGlobale,
        netapayer: SumNetAPayer,
        snackbaropen: true,
        btnEnabled: true,
      });

      this.setState({
        codearticle: "",
        qte: "",
        totalht: 0,
        des: "",
        unite: "",
        puht: "",
        remisea: 0,
        tva: 0,
        puttcnet: 0,
        faudec: "N",
        pmps: "",
        stkfin: 0,
        codtvaa: 0,
        ttclig: "",
      });
    }
  };

  sameTable = () => {
    fetch(
      `https://www.24-crm.tn/webservice/api/LIGBCDVFrs?type=CF&numfac=${this.props.bcid}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`
    )
      .then((response) => response.json())
      .then((data) => {
        this.setState({
          tab: data,
        });
      });
  };

  puttcHandler = (event) => {
    this.setState({
      puttcnet: event.target.value,
      puht: Number(
        event.target.value /
          ((100 - this.state.remisea) / 100) /
          (1 + this.state.tva / 100)
      ).toFixed(3),
      totalht: Number(
        this.state.qte *
          ((event.target.value /
            ((100 - this.state.remisea) / 100) /
            (1 + this.state.tva / 100)) *
            ((100 - this.state.remisea) / 100))
      ).toFixed(3),
      ttclig: Number(event.target.value * this.state.qte).toFixed(3),
    });
  };

  qteHandler = (event) => {
    event.preventDefault();
    this.setState({
      qte: event.target.value,
      puttcnet: Number(
        this.state.puht *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
      totalht: Number(
        event.target.value *
          this.state.puht *
          ((100 - this.state.remisea) / 100)
      ).toFixed(3),
      ttclig: Number(
        this.state.puht *
          (1 + this.state.tva / 100) *
          ((100 - this.state.remisea) / 100) *
          event.target.value
      ).toFixed(3),
    });
  };
  handleChange = (name) => (event) => {
    this.setState({ [name]: event.target.checked });
  };

  snackbarClose = (event) => {
    this.setState({ snackbaropen: false });
  };

  snackbarFailClose = (event) => {
    this.setState({ snackbarfail: false });
  };

  deleteRow = (index) => {
    var tab = [...this.state.tab];
    tab.splice(index, 1);
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.quantite), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce(
        (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
        0
      );
    const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
    const SumTva =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          parseInt(v.quantite) *
            v.priuni *
            ((100 - v.remise) / 100) *
            (v.tautva / 100),
        0
      );
    const SumHtNet =
      tab &&
      tab.reduce((a, v) => a + v.montht * ((100 - this.props.rem) / 100), 0);
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
    const SumNetAPayer =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          (v.totalht * ((100 - this.props.rem) / 100) +
            parseInt(v.quantite) *
              v.priuni *
              ((100 - v.remise) / 100) *
              (v.tautva / 100)),
        0
      );

    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      snackbarfail: true,
      btnEnabled: true,
    });
  };

  deleteRowMod = (index) => {
    var tab = [...this.state.tab];
    tab.splice(index, 1);
    const SumQte = tab && tab.reduce((a, v) => a + parseInt(v.quantite), 0);
    const SumRemiseArticle =
      tab &&
      tab.reduce(
        (a, v) => a + (parseInt(v.quantite) * v.priuni * v.remise) / 100,
        0
      );
    const SumHtBrut =
      tab && tab.reduce((a, v) => a + parseInt(v.quantite) * v.priuni, 0);
    const SumTva =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          parseInt(v.quantite) *
            v.priuni *
            ((100 - v.remise) / 100) *
            (v.tautva / 100),
        0
      );
    const SumHtNet =
      tab &&
      tab.reduce((a, v) => a + v.montht * ((100 - this.props.rem) / 100), 0);
    const SumRemiseGlobale =
      tab && tab.reduce((a, v) => a + v.montht * (this.props.rem / 100), 0);
    const SumNetAPayer =
      tab &&
      tab.reduce(
        (a, v) =>
          a +
          (v.montht * ((100 - this.props.rem) / 100) +
            parseInt(v.quantite) *
              v.priuni *
              ((100 - v.remise) / 100) *
              (v.tautva / 100)),
        0
      );

    this.setState({
      tab,
      totalqte: SumQte,
      sumremisearticle: SumRemiseArticle,
      totalhtbrut: SumHtBrut,
      totaltva: SumTva,
      totalhtnet: SumHtNet,
      remiseglobal: SumRemiseGlobale,
      netapayer: SumNetAPayer,
      btnEnabled: true,
    });
  };

  enrsnackbarClose = (event) => {
    this.setState({ enrsnackbaropen: false });
  };

  fsnackbarClose = (event) => {
    this.setState({ fsnackbaropen: false });
  };

  onCellChange = (event) => {
    this.setState({ codearticle: event.target.value });
  };

  ///////////// delete for modification without snackbaropende ///////////

  enregistrer = () => {
    /////////////// Update bcdv //////////////////////
    fetch(
      `https://www.24-crm.tn/webservice/api/BCDVFrs?numfac=${this.props.bcid}&typfac=CF&datfac=${this.state.datebcc}&codcli=${this.state.codeclient}&raisoc=${this.state.raisonsocial}&taurem=${this.state.remiseg}&catfisc=${this.state.categoriefiscale}&timbre=${this.props.droitdetimbre}&valtimbre=${this.props.valtimbre}&ForfaitCli=${this.props.avanceimpot}&vendeur=${this.props.Auth.username}&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
      {
        method: "PUT",
        header: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    )
      .then((result) => {
        console.log("mise a jour stock avec succée");

        ////////// first part delete ///////////////////
        fetch(
          `https://www.24-crm.tn/webservice/api/LIGBCDVFrs/${this.props.bcid}?typfacc=CF&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
          {
            method: "DELETE",
            header: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
          }
        )
          .then((res) => res.json())

          .then(() => {
            this.state.tab.map((k, index) => {
              // for (var i = 0; i < this.state.tab.length; i++) {
              fetch(
                `https://www.24-crm.tn/webservice/api/LIGBCDVFrs/{ID}?numfac=${
                  this.props.bcid
                }&typfac=CF&numlig=${index + 10}&codart=${k.codart}&quantite=${
                  k.quantite
                }&fodart=0&desart=${k.desart}&datfac=${
                  this.props.datebl
                }&priuni=${k.priuni}&remise=${k.remise}&unite=${
                  k.unite
                }&codtva=${k.codtva}&tautva=${k.tautva}&pmp=${k.pmp}&ttclig=${
                  k.ttclig
                }&montht=${k.montht}&coddos=${
                  this.props.ConfigDossier.coddos
                }&serveur=${this.props.ConfigDossier.serveur}&user=${
                  this.props.ConfigDossier.utilisateur
                }&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${
                  this.props.ConfigDossier.database
                }`,
                {
                  method: "POST",
                  header: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                  },
                }
              )
                .then((res) => res.json())

                .then(
                  () => {
                    //  executer la procédure SommeTTCBCDV
                    fetch(
                      `https://www.24-crm.tn/webservice/api/LIGBCDVFrs?FAC=${this.props.bcid}&typfacc=CF&coddos=${this.props.ConfigDossier.coddos}&serveur=${this.props.ConfigDossier.serveur}&user=${this.props.ConfigDossier.utilisateur}&pwd=${this.props.ConfigDossier.pwd_serveur}&database=${this.props.ConfigDossier.database}`,
                      {
                        method: "POST",
                        header: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                        },
                      }
                    )
                      .then((res) => res.json())
                      .then(
                        (result) => {
                          window.location.reload();
                        },

                        () => {
                          this.setState({
                            enrsnackbaropen: true,
                            snackbarmsg: "failed",
                          });
                        }
                      );
                    // }
                  },
                  (error) => {
                    this.setState({
                      enrsnackbaropen: true,
                      snackbarmsg: "failed",
                    });
                  }
                );
            });
          });
      })
      .then(
        (result) => {
          this.props.onHide();

          this.props.SelectBCFrs(
            this.props.ConfigDossier.coddos,
            this.props.ConfigDossier.serveur,
            this.props.ConfigDossier.utilisateur,
            this.props.ConfigDossier.pwd_serveur,
            this.props.ConfigDossier.database
          );
        },
        (error) => {
          this.setState({ snackbaropen: true, snackbarmsg: "failed" });
        }
      );
  };

  render() {
    const { darck, classes } = this.props;

    return (
      <div className="container">
        <Snackbar
          open={this.state.snackbaropen}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarClose}
            severity="success"
          >
            Article ajouté
          </Alert>
        </Snackbar>

        <Snackbar
          open={this.state.snackbarfail}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          onClose={this.snackbarFailClose}
        >
          <Alert
            style={{ height: "50px" }}
            onClose={this.snackbarFailClose}
            severity="error"
          >
            Article supprimé
          </Alert>
        </Snackbar>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={this.state.enrsnackbaropen}
          autoHideDuration={2000}
          onClose={this.enrsnackbarClose}
          message={<span id="message-id"> {this.state.snackbarmsg} </span>}
          action={[
            <IconButton
              key="close"
              color="inherit"
              onClick={this.enrsnackbarClose}
            >
              x
            </IconButton>,
          ]}
        ></Snackbar>

        <Modal
          {...this.props}
          size="xl"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          backdrop={false}
        >
          <Modal.Header closeButton 
           style={{
              backgroundColor: `${darck ? "#fff" : "#172431"}`,
              color: `${darck ? "#020F64" : "#fff"}`,
              borderTop: `${darck ? "" : "2px solid #fff"}`,
              borderRight: `${darck ? "" : "2px solid #fff"}`,
              borderLeft: `${darck ? "" : "2px solid #fff"}`,
              borderBottom: `none`,}}
              >
            <Modal.Title id="contained-modal-title-vcenter">
              <b>Modifier Bon de commande № {this.props.bcid}</b>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{
                                  backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                  border: `${darck ? "" : "2px solid #fff"}`,
                                  borderBottom: `none`,
                                }}>
            <Row>
              <Col  style={{ margin: "0" }}>
                <Card style={{ marginBottom: "10px" }}>
                  <Card.Body style={{
                                backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                border: `${darck ? "" : "2px solid #fff"}`,
                              }}>
                    <Row style={{ marginBottom: "-20px", marginTop: "-20px" }}>
                      <Col sm={8}>
                        <FormGroup>
                          <Typography component="div">
                            <Grid
                              component="label"
                              container
                              alignItems="center"
                              spacing={1}
                            >
                              <Grid style={{ color: `${darck ? "" : "#fff"}` }}> 
                                <b>Chercher Fournisseur par :</b>
                              </Grid>
                              &nbsp;&nbsp;
                              <Grid item style={{ color: "grey" }}>
                                Raison sociale
                              </Grid>
                              <Grid item>
                                <Switch
                                  checked={this.state.giladd}
                                  onChange={this.handleChange("giladd")}
                                  value="giladd"
                                  color="primary"
                                />
                              </Grid>
                              <Grid item style={{ color: "#3f51b5" }}>
                                Code Fournisseur
                              </Grid>
                            </Grid>
                          </Typography>
                        </FormGroup>
                      </Col>

                      {this.state.giladd ? (
                        <Col sm={4} style={{  marginBottom: "15px" ,paddingLeft: "105px"}}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              // options={this.props.clients.clients}
                              // options={this.state.rechsc}
                              options={
                                this.state.clicked
                                  ? this.state.rechsc
                                  : this.props.fournisseurs.fournisseurs
                              }
                              getOptionLabel={(option) => option.codfrs}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      raisonsocial: getOptionLabel.raisoc,
                                      remiseg: getOptionLabel.remise,
                                      codeclient: getOptionLabel.codfrs,
                                      btnEnabled: true,
                                      showTimbre: getOptionLabel.timbre,
                                      cemail: getOptionLabel.email,
                                    })
                                  : this.setState({
                                      raisonsocial: this.props.raisonsociale,
                                      remiseg: this.props.taurem,
                                      codfrs: this.props.client,
                                      btnEnable: false,
                                      showTimbre: false,
                                      showForfitaire: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Code Fournisseur"
                                  className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.clientHandlerChange}
                                  name="codcli"
                                  // InputProps={{
                                  //   ...params.InputProps,
                                  //   className: !darck
                                  //     ? this.props.classes.input
                                  //     : null,
                                  // }}
                                  inputProps={params.inputProps}
                                  id={params.id}
                                  InputLabelProps={{
                                    style: {
                                      color: !darck ? "#fff" : null,
                                    },
                                  }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      ) : (
                        <Col sm={4} style={{  marginBottom: "15px" ,paddingLeft: "105px"}}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              // options={this.props.clients.clients}
                              // options={this.state.rechsc}
                              options={
                                this.state.clicked
                                  ? this.state.rechsc
                                  : this.props.fournisseurs.fournisseurs
                              }
                              getOptionLabel={(option) => option.raisoc}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      raisonsocial: getOptionLabel.raisoc,
                                      remiseg: getOptionLabel.remise,
                                      codeclient: getOptionLabel.codfrs,
                                      btnEnabled: true,
                                      showTimbre: getOptionLabel.timbre,
                                      cemail: getOptionLabel.email,
                                    })
                                  : this.setState({
                                      raisonsocial: this.props.raisonsociale,
                                      remiseg: this.props.taurem,
                                      codfrs: this.props.client,
                                      btnEnable: false,
                                      showTimbre: false,
                                      showForfitaire: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Raison sociale"
                                  className="card add-input"
                                  margin="dense"
                                  variant="outlined" //variant="outlined"
                                  fullWidth
                                  onChange={this.clientHandlerChange}
                                  name="raissoc"
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>

                    <Row style={{ marginBottom: "-20px" }}>
                      <Col sm={2}>
                        <FormGroup>
                          <TextField
                            id="standard-basic"
                            label="Code Fournisseur"
                            className="card add-input"
                            margin="dense"
                            variant="outlined" //variant="outlined"
                            value={this.state.codeclient}
                            fullWidth
                            name="codcli"
                            disabled
                            InputLabelProps={{
                              shrink: true,
                            }}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={5}>
                        <FormGroup>
                          <TextField
                            id="standard-basic"
                            label="Raison sociale"
                            className="card add-input"
                            margin="dense"
                            variant="outlined" //variant="outlined"
                            value={this.state.raisonsocial}
                            fullWidth
                            name="raissoc"
                            disabled={
                              this.state.codeclient === "100" ? false : true
                            }
                            onChange={this.raisocHandler}
                          />
                        </FormGroup>
                      </Col>

                      <Col sm={2}>
                        <TextField
                          id="standard-basic"
                          label="Remise Globale %"
                          className="card add-input"
                          margin="dense"
                          variant="outlined" //variant="outlined"
                          fullWidth
                          name="remise"
                          InputLabelProps={{
                            shrink: true,
                          }}
                          onChange={this.remiseglobalChange}
                          value={this.state.remiseg}
                        />
                      </Col>

                      <Col sm={3}>
                        <TextField
                          id="standard-basic"
                          label="Date"
                          className="card add-input"
                          margin="dense"
                          variant="outlined"
                          type="date"
                          fullWidth
                          name="datfac"
                          onChange={this.datHandler}
                          value={this.state.datebcc}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Col>
                    </Row>
                  </Card.Body>
                </Card>

                <Card>
                  <Card.Body style={{
                                backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                border: `${darck ? "" : "2px solid #fff"}`,
                              }}>
                  <form
                      autocomplete="off"
                      onSubmit={this.submitHandler}
                      // className={`${darck ? "" : classes.root}`}
                    >
                      <Row form>
                        <b style={{ color: `${darck ? "" : "#fff"}` }}>Chercher article par :</b>
                        <b style={{ marginTop: "10px", marginLeft: "10px" }}>
                          {this.state.faudec === "A" ? (
                            <p style={{ color: "grey" }}>Fodec: ✔</p>
                          ) : null}
                        </b>
                      </Row>
                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clickeda
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: getOptionLabel.PUDHT,
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "N",
                                      stkfin: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                   {...params}
                                  label="Code article"
                                   className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  // InputProps={{
                                  //   ...params.InputProps,
                                  //   className: !darck
                                  //     ? this.props.classes.input
                                  //     : null,
                                  // }}
                                  // inputProps={params.inputProps}
                                  // id={params.id}
                                  // InputLabelProps={{
                                  //   style: {
                                  //     color: !darck ? "#fff" : null,
                                  //   },
                                  // }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>


                        <Col sm={6}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clickeda
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.desart}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: getOptionLabel.PUDHT,
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: "",
                                      remisea: 0,
                                      tva: 0,
                                      faudec: "N",
                                      stkfin: 0,
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                   {...params}
                                  label="Désignation article"
                                   className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  // InputProps={{
                                  //   ...params.InputProps,
                                  //   className: !darck
                                  //     ? this.props.classes.input
                                  //     : null,
                                  // }}
                                  // inputProps={params.inputProps}
                                  // id={params.id}
                                  // InputLabelProps={{
                                  //   style: {
                                  //     color: !darck ? "#fff" : null,
                                  //   },
                                  // }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>


                        <Col sm={3}>
                          <FormGroup>
                            <Autocomplete
                              id="include-input-in-list"
                              includeInputInList
                              className="ajouter-client-input"
                              //   options={this.props.articles.articles}
                              // options={this.state.rechs}
                              options={
                                this.state.clicked
                                  ? this.state.rechs
                                  : this.props.articles.articles
                              }
                              getOptionLabel={(option) => option.codbar}
                              onChange={(event, getOptionLabel) => {
                                getOptionLabel
                                  ? this.setState({
                                      codearticle: getOptionLabel.codart,
                                      des: getOptionLabel.desart,
                                      unite: getOptionLabel.unite,
                                      puht: Number(
                                        getOptionLabel.PUDHT
                                      ).toFixed(3),
                                      remisea: getOptionLabel.remise,
                                      tva: getOptionLabel.tautva,
                                      faudec: getOptionLabel.typfodec,
                                      stkfin: getOptionLabel.stkfin,
                                      codtvaa: getOptionLabel.codtva,
                                      codbar: getOptionLabel.codbar,
                                      pmp: getOptionLabel.pmp,
                                    })
                                  : this.setState({
                                      codearticle: "",
                                      totalht: 0,
                                      des: "",
                                      unite: "",
                                      puht: 0,
                                      remisea: 0,
                                      stkfin: 0,
                                      tva: 0,
                                      codtvaa: "",
                                      codbar: "",
                                      faudec: "N",
                                      pmp: "",
                                    });
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Code à Barre"
                                   className="card add-input"
                                  margin="dense"
                                  variant="outlined"
                                  fullWidth
                                  onChange={this.articleHandlerChange}
                                  // InputProps={{
                                  //   ...params.InputProps,
                                  //   className: !darck
                                  //     ? this.props.classes.input
                                  //     : null,
                                  // }}
                                  // inputProps={params.inputProps}
                                  // id={params.id}
                                  // InputLabelProps={{
                                  //   style: {
                                  //     color: !darck ? "#fff" : null,
                                  //   },
                                  // }}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>



                      </Row>

                      <Row form>
                        <Col sm={3}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Code article"
                              value={this.state.codearticle}
                              disabled
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={6}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Désignation"
                              value={this.state.des}
                              disabled
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={1}>
                          <FormGroup>
                            {/* {this.state.des === "" ? (
                              <TextField
                                id="standard-basic"
                                label="Quantité"
                                type="number"
                                disabled
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                style={{ marginTop: "16px" }}
                                margin="normal"
                                fullWidth
                                required
                              />
                            ) : ( */}
                            <TextField
                              id="standard-basic"
                              label="Qte"
                              type="number"
                              InputLabelProps={{
                                shrink: true,
                                style: {
                                  textAlign: "center",
                                },
                              }}
                              inputStyle={{ textAlign: "center" }}
                              value={this.state.qte}
                              onChange={this.qteHandler}
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                              fullWidth
                              required
                            />
                            {/* )} */}
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              value={`Stock: ${this.state.stkfin}`}
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                              disabled
                            />
                          </FormGroup>
                        </Col>
                      </Row>
                      <Row form>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Unité"
                              value={this.state.unite}
                              fullWidth
                              disabled
                              size="small"
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="PU HT"
                              value={this.state.puht}
                              fullWidth
                              name="puht"
                              onChange={this.puhtHandler}
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Remise %"
                              value={this.state.remisea}
                              fullWidth
                              name="remisea"
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                              onChange={this.remiseHandler}
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="TVA"
                              value={this.state.tva}
                              fullWidth
                              disabled
                              size="small"
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                            />
                          </FormGroup>
                        </Col>

                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="PU TTC Net"
                              value={Number(this.state.puttcnet).toFixed(3)}
                              fullWidth
                              onChange={this.puttcHandler}
                              size="small"
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                            />
                          </FormGroup>
                        </Col>
                        <Col sm={2}>
                          <FormGroup>
                            <TextField
                              id="standard-basic"
                              label="Total HT"
                              value={this.state.totalht}
                              fullWidth
                              disabled
                              size="small"
                              className="card add-input"
                              margin="dense"
                              variant="outlined"
                            />
                          </FormGroup>
                        </Col>
                      </Row>

                      {this.state.changeButton ? (
                        <Center>
                          <Button
                            style={{ width: "320px" }}
                            variant="contained"
                            color="primary"
                            onClick={() => {
                              this.modifiermodification();
                            }}
                          >
                            Enregistrer les modifications
                          </Button>
                        </Center>
                      ) : this.state.des === "" ? (
                        <Center>
                          <Button
                            disabled
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            Ajouter
                          </Button>
                        </Center>
                      ) : (
                        <Center>
                          <Button
                            style={{ width: "250px" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                          >
                            Ajouter
                          </Button>
                        </Center>
                      )}
                    </form>
                  </Card.Body>
                </Card>
 {/* ////////Responsive////////// */}
                <Card style={{ marginTop: "10px" }}>
                  <Card.Body  style={{
                                    backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                    border: `${darck ? "" : "2px solid #fff"}`,
                                  }}>
                    <div className="tabd28">
                      <table style={{ marginTop: "10px" }}>
                        <thead
                          style={{ fontSize: "12px",textAlign: "center" }}
                         >
                          <tr>
                            <th>Code</th>
                            <th style={{ width: "40%" }}>Désignation</th>
                            <th>Quantité</th>
                            <th>PUHT</th>
                            <th>Remise</th>
                            <th>TVA</th>
                            <th>TotalHT</th>
                            <th>PUTTCNET</th>
                            <th></th>
                            <th></th>
                          </tr>
                        </thead>
                        <tbody
                          style={{
                            overflowY: "auto",
                            display: "block",
                            maxHeight: "10em",
                            color: `${darck ? "" : "#fff"}`,
                          }}
                        >
                          {this.state.tab.map((t, i) => (
                            <tr key={i}>
                              <td>
                                <span>{t.codart}</span>
                              </td>
                              <td style={{ fontSize: "12px", width: "40%" }}>
                                {t.desart}
                              </td>
                              <td>
                                <span>{t.quantite}</span>
                              </td>
                              <td>
                                <span>{Number(t.priuni).toFixed(3)}</span>
                              </td>

                              <td>
                                <span>{Number(t.remise).toFixed(2)}</span>
                              </td>
                              <td>
                                <span>{Number(t.tautva).toFixed(2)}</span>
                              </td>

                              <td>
                                <span>{Number(t.montht).toFixed(3)}</span>
                              </td>
                              <td style={{ color: `${darck ? "" : "#fff"}` }}>
                                <span>{Number(t.PUTTCNET).toFixed(3)}</span>
                              </td>
                              <td>
                                <Tooltip title="Modifier cet article">
                                  <Fab size="small">
                                    <EditIcon
                                      style={{}}
                                      onClick={() => {
                                        this.setState({
                                          codearticle: t.codart,
                                          des: t.desart,
                                          unite: t.unite,
                                          puht: Number(t.priuni).toFixed(3),
                                          remisea: t.remise,
                                          tva: t.tautva,
                                          faudec: t.typfodec,
                                          qte: t.quantite,
                                          totalht: t.montht,
                                          puttcnet: t.PUTTCNET,
                                          pmps: t.pmp,
                                          codtvaa: t.codtva,
                                          ttclig: t.ttclig,
                                          changeButton: true,
                                        });
                                        this.deleteRowMod(i);
                                      }}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                              <td>
                                <Tooltip title="Supprimer cet article">
                                  <Fab size="small">
                                    <DeleteIcon
                                      onClick={() => this.deleteRow(i)}
                                    />
                                  </Fab>
                                </Tooltip>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Modal.Body>
          <Modal.Footer style={{
                                backgroundColor: `${darck ? "#fff" : "#172431"}`,
                                border: `${darck ? "" : "2px solid #fff"}`,
                              }}>
            {!this.state.btnEnabled ? (
              <Button disabled variant="contained">
                Enregistrer
              </Button>
            ) : (
              <Button
                variant="contained"
                style={{ backgroundColor: "rgb(0, 8, 126)", color: "white" }}
                onClick={() => {
                  // this.props.submitHandler(this.state.tab,
                  //     this.state.totalqte,
                  //     this.state.sumremisearticle,
                  //     this.state.totalhtbrut,
                  //     this.state.totaltva,
                  //     this.state.totalhtnet,
                  //     this.state.remiseglobal,
                  //     this.state.netapayer,
                  //     this.state.btnEnabled,
                  // )

                  
                  this.enregistrer();
                  this.props.onHide();
                  this.props.onHide01();
                  window.alert("Modification enregistrés");
                }}
              >
                Enregistrer
              </Button>
            )}
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    SelectArticle: (a, b, c, d, e) => dispatch(SelectArticle(a, b, c, d, e)),
    SelectBCFrs: (a, b, c, d, e) => dispatch(SelectBCFrs(a, b, c, d, e)),
    SelectFournisseur: (a, b, c, d, e) =>
      dispatch(SelectFournisseur(a, b, c, d, e)),
  };
}

function mapStateToProps(state) {
  return {
    articles: state.articles,
    fournisseurs: state.fournisseurs,
    Auth: state.Auth,
    ConfigDossier: state.ConfigDossier,
   darck: state.darck.darck,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ModifierBCFrsModal);
